import { jsx as _jsx } from "react/jsx-runtime";
import "bootstrap";
import jquery from "jquery";
window.$ = window.jQuery = jquery;
import * as bootbox from "bootbox";
import { I18n } from "react-redux-i18n";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { log } from "../../commons";
export async function confirmBox(conf) {
    return new Promise((resolve) => {
        bootbox.dialog({
            title: conf.title,
            message: conf.message,
            size: conf.size,
            closeButton: false,
            className: `kp-boot`,
            buttons: {
                yesButton: {
                    label: conf.yesText || "YES",
                    className: "btn-primary",
                    callback: async () => {
                        if (conf.yesFunc) {
                            await conf.yesFunc();
                        }
                        resolve(true);
                    },
                },
                noButton: {
                    label: conf.noText || "NO",
                    className: "btn-secondary",
                    callback: async () => {
                        if (conf.noFunc) {
                            await conf.noFunc();
                        }
                        resolve(false);
                    },
                },
            },
        });
    });
}
export function askConfirmation(confirmation) {
    return confirmBox({
        message: I18n.t(confirmation),
        noText: I18n.t("kptable.confirm.no"),
        yesText: I18n.t("kptable.confirm.yes"),
        title: I18n.t("kptable.confirm.title"),
    });
}
export function objectToParamFilter(obj) {
    if (!obj) {
        return [];
    }
    else {
        return Object.keys(obj)
            .filter((k) => obj[k])
            .map((k) => ({ name: k, value: obj[k] }));
    }
}
export function tooltipate(element, tooltip) {
    return tooltip ? (_jsx(OverlayTrigger, { placement: "top", overlay: _jsx(Tooltip, { id: `tooltip-${Math.random()}`, children: tooltip }), children: element }, Math.random())) : (element);
}
export function loadFromLS(id) {
    try {
        const stateStr = localStorage.getItem(`KPTABLE_${id}`);
        return stateStr ? JSON.parse(stateStr) : {};
    }
    catch (e) {
        log(e);
        return {};
    }
}
export function saveFromLS(id, state) {
    try {
        localStorage.setItem(`KPTABLE_${id}`, JSON.stringify(state[id] || {}));
    }
    catch (e) {
        log(e);
    }
    return state;
}
